import React from 'react';
import {connect} from 'react-redux';
import {
	closeTripFormatsCarouselPopup,
	updateEditTripFormatsCarouselSection,
} from '../../actions';
import {
	updateTitleFieldInTheSectionEditPopup,
	updateBodyFieldInTheSectionEditPopup,
} from '../../sections/actions';

import TripFormatsCarouselSectionEditPopup from './trip_formats_carousel_section_edit';

class TripFormatsCarouselPopup extends React.Component {

	render () {

		return (
			<TripFormatsCarouselSectionEditPopup
				open={this.props.tripFormatsCarouselSectionEditOpen}
				title={this.props.tripFormatsCarouselSectionTitle}
				body={this.props.tripFormatsCarouselSectionBody}
				pageId={this.props.pageId}
				sectionId={this.props.tripFormatsCarouselSectionId}
				onUpdateTitleField={
					title => this.props.updateTripFormatsCarouselSectionTitleField(title)
				}
				onUpdateBodyField={
					body => this.props.updateTripFormatsCarouselSectionBodyField(body)
				}
				onHandleSubmit={() =>
					this.props.updateTripFormatsCarouselSectionContents(
						this.props.pageId,
						this.props.tripFormatsCarouselSectionId,
						this.props.sectionData,
					)
				}
				onHandleClose={
					() => this.props.closeTripFormatsCarouselSectionPopup()
				}
			/>
		)
	}


}

const mapStateToProps = (state, props) => ({
	sectionData: state.pageBuilderSectionPopup.data,
	tripFormatsCarouselSectionEditOpen: state.pageBuilder.tripFormatsCarouselSectionPopup.open,
	tripFormatsCarouselSectionTitle: state.pageBuilderSectionPopup.data.title,
	tripFormatsCarouselSectionBody: state.pageBuilderSectionPopup.data.body,
	tripFormatsCarouselSectionId: state.pageBuilderSectionPopup.sectionId,
});

export default connect(
	mapStateToProps, {
		closeTripFormatsCarouselSectionPopup: closeTripFormatsCarouselPopup,
		updateTripFormatsCarouselSectionTitleField: updateTitleFieldInTheSectionEditPopup,
		updateTripFormatsCarouselSectionBodyField: updateBodyFieldInTheSectionEditPopup,
		updateTripFormatsCarouselSectionContents: updateEditTripFormatsCarouselSection,
	}
)(TripFormatsCarouselPopup);


// WEBPACK FOOTER //
// ./src/containers/builder/form/popups/trip_formats_carousel_popup.js